namespace JupitersChoice {
    export class CheckSpinnerPrizeCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('FreeSpinsPromoModel') _freeSpinsPromoModel: Sapphire.FreeSpinsPromoModel;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('StageLoadModel') _stageLoadModel: Sapphire.StageLoadModel;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;

        execute(): void {
            const response: any = this._server.logicResponse;

            if (response.feature && response.feature.type === 'payout') {
                this._eventManager.publish('onHasNoFreeGame');
            } else {
                // check that free game stage has fully loaded, if not, kick player back to preloader
                if (!this._stageLoadModel.hasStageLoaded("FreeGame")) {
                    Sapphire.Logger.log("FreeGame assets yet to fully load, waiting...");
                    this._componentManager.get('Preloader').restart();
                    this._stageLoadModel.nextBundleRequiredIndex = 1;
                    this._eventManager.publish("onShowPreloader");
                } else {
                    this._eventManager.publish('onHasFreeGame');

                    // reset free spin counter
                    let freeSpinCountText = this._translationsManager.get('framework.xofy').replace('{0}', 0);
                    freeSpinCountText = freeSpinCountText.replace('{1}', response.feature.value);
                    this._componentManager.get('FreeSpinsCounter').setText(freeSpinCountText);

                    if (this._freeSpinsPromoModel.isInProgress) {
                        this._componentManager.get('FreeSpinsPromoSpinCounter').hide();
                    }
                }
            }
        }
    }
}